module.exports = __webpack_public_path__ + "static/media/Level03.39b258bf.jpg";